var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8197 6.04C19.216 6.04 19.5734 5.80125 19.725 5.43508C19.8768 5.06883 19.7929 4.64733 19.5126 4.36708L15.3476 0.20208L13.9617 1.588L16.4538 4.08L6.0797 4.08L6.0797 6.04L18.8197 6.04ZM1.17978 9.96C0.783362 9.96 0.426028 10.1988 0.274362 10.5649C0.122612 10.9312 0.206528 11.3527 0.486778 11.6329L4.65178 15.7979L6.0377 14.412L3.5457 11.92L13.9197 11.92L13.9197 9.96L1.17978 9.96Z",
    fill: "url(#paint0_linear_106_417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_417",
    x1: 3.5,
    y1: 10.5,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CB6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/transaction-icon.443b33b6c5eb3e19ae6cd23fccd57aab.svg";
export { ForwardRef as ReactComponent };